import React from "react"

export default function Home() {
  return <div>Hello world! Now get me onto Github Pages.</div>
}
